// La scelta dell'avatar nel form del pop: a sinistra il pop scelto, a destra le 5 varianti del
// ruolo scelto nel campo «Ruolo», che filtra i pops.
import { Pop } from '../../components/Pop';
import { POP_ROLES, popVariants } from '../../lib/pops';

export function PopPicker({
  role,
  value,
  onChange,
}: {
  role: string | null;
  value: string | null;
  onChange: (avatar: string) => void;
}) {
  const label = POP_ROLES.find((r) => r.id === role)?.label ?? '';

  return (
    <div className="pop-picker">
      <div className="pop-picker-stage" aria-hidden="true">
        {value ? <Pop avatar={value} size={96} /> : <span className="t-caption faint">—</span>}
      </div>
      {role ? (
        <div role="group" aria-label={label} className="pop-picker-variants">
          {popVariants(role).map((a, i) => {
            const on = a === value;
            return (
              <button
                key={a}
                type="button"
                aria-pressed={on}
                aria-label={`${label} ${i + 1}`}
                className="pop-picker-variant"
                data-on={on || undefined}
                onClick={() => onChange(a)}
              >
                <Pop avatar={a} size={72} />
              </button>
            );
          })}
        </div>
      ) : (
        <div className="t-small dim">Scegli prima il ruolo: qui compaiono i suoi pops.</div>
      )}
    </div>
  );
}
